const isString = (value) => typeof value === "string";
export default isString;
